import { MediaChange, MediaObserver } from "@ngbracket/ngx-layout";
import { EventEmitter, Injectable } from "@angular/core";

@Injectable()
export class WtfMatchMedia {
    activeMediaQuery: string;
    onMediaChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(public observableMedia: MediaObserver) {
        this.activeMediaQuery = "";

        this.observableMedia.asObservable().subscribe((value) => {
            if (this.activeMediaQuery !== value[0].mqAlias) {
                this.activeMediaQuery = value[0].mqAlias;
                this.onMediaChange.emit(value[0].mqAlias);
            }
        });
    }
}
